import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonObservableService {
  filterTriggered: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false,
  );

  private tableLoadingSubject = new BehaviorSubject<boolean>(false);

tableLoading$ = this.tableLoadingSubject.asObservable();
  private loadingRequests = 0;

setTableLoading(value: boolean): void {
  this.tableLoadingSubject.next(value);
}


  startLoading(): void {
    this.loadingRequests++;

    this.tableLoadingSubject.next(true);
  }


  stopLoading(): void {
    this.loadingRequests--;

    if (this.loadingRequests <= 0) {
      this.loadingRequests = 0;

      this.tableLoadingSubject.next(false);
    }
  }


  setFilterTriggeredData(data: boolean) {
    this.filterTriggered.next(data);
  }

  getFilterTriggeredData(): Observable<boolean> {
    return this.filterTriggered.asObservable();
  }

  filterFormData: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  setFilterFormData(data: any) {
    this.filterFormData.next(data);
  }

  getFilterFormData(): Observable<any> {
    return this.filterFormData.asObservable();
  }

  constructor() {}
}
